import templates from "template";
import $ from "jquery";
import c from "common";
import collapsible from "collapsible";
import formHelpers from "form-helpers";
import translate from "translate";
import validate from "validate";
import ga from "analytics";
import scroll from "scroll";
import mobileLinks from "mobile-links";
import Bacon from "Bacon.plugins";
import {getPlatform} from "vod/platforms";

var $html = $(document.documentElement);
var $body = $(document.body);

var paymentOptionStream, closeModalStream, modalOpenState,
  $modalContainer = $('.modalContainer'),
  $modal,
  modalStream = new Bacon.Bus(),
  fullscreen = new Bacon.Bus(),
  fullscreenState = fullscreen.toProperty(false),
  streams, methods;

var ALLOWED = 'ALLOWED';
var UNKNOWN = 'UNKNOWN';
var DENIED = 'DENIED';
var ALLOWED_BULLETIN = 'ALLOWED_BULLETIN';
var ALLOWED_INTERNAL = 'ALLOWED_INTERNAL';

function render(template, data, partials) {
  data.firstRender = !$html.hasClass("modal-open");
  data.platform = getPlatform();
  return template.render(data, partials);
}

function isChecked(event) {
  return $(event.target).is(":checked");
}

function isModalOpen() {
  return $html.hasClass("modal-open");
}

function createCloseModalButton() {
  return $(document.createElement('a')).addClass('close').html('<span>&nbsp;</span>').attr('href', '#close');
}

function removeModal() {
  $modalContainer.children().remove();
  $modal = null;
}

function createModal(html) {
  var element = document.createElement('div');
  removeModal();
  setupModalAnimations(element);
  return $(element).addClass('modal').html(html).prepend(createCloseModalButton());
}

function modalAnimationEnd() {
  window.setTimeout(function () {
    $body.removeClass("modal-open-animation");
  }, 100);
}

function setupModalAnimations(element) {
  element.addEventListener("webkitAnimationEnd", modalAnimationEnd, false);
  element.addEventListener("animationend", modalAnimationEnd, false);
}

function renderModal(template, loginPartials, data) {
  var html = render(template, data, loginPartials);
  $modal = createModal(html).appendTo($modalContainer);
  $modal.toggleClass('no-animation', data.animate === false);
  if (!isModalOpen()) {
    $body.addClass("modal-open-animation");
  }
  $modal.addClass(data.modalClass);
  var top = scroll.top();
  $html.addClass('modal-open');
  $('.wrapper').scrollTop(top);
  $modal.trigger("mouseover");
  $modal.find("input[type='text'], input[type='password']").each(function () {
    var $this = $(this);
    if ($this.height() > 0 && !$this.prop('disabled')) {
      $this.focus();
      return false;
    }
  });
  return data;
}

function closeModal() {
  methods.close();
}

function emailIsForBilling() {
  return $(".login-header").attr("data-email-is-for-billing") === "true";
}

function emailIsNotForBilling() {
  return !emailIsForBilling();
}

function triggerOpen() {
  $("#email-modal").trigger("input");
  $('#termsAccepted').trigger("change");
  $('#pin').trigger('keyup');
  $("input[name='payment-option']:checked").trigger("change");
  $('.email input[name="marketingConsent"]:checked').trigger("change");
}

function setupAgreementNotCheckedStream() {
  var agreementChecked = $body.asEventStream("click change", ".modal #termsAccepted").map(isChecked).toProperty($body.hasClass("termsAccepted"));
  agreementChecked.not().lazyAssign($, "#termsAccepted", "toggleClass", "missing");
  agreementChecked.filter(c.isTrue).map("collapsible").lazyAssign($, ".modal .agreement", "addClass");
  agreementChecked.lazyAssign($, ".modal .agreement", "toggleClass", "collapsed");
  return agreementChecked.not();
}

function isPurchaseOptionWithPinCode(purchaseOption) {
  return purchaseOption === "invoice";
}

function setupInvalidPinStream() {
  var paymentOptionRequiresPinCode = paymentOptionStream.map(isPurchaseOptionWithPinCode).toProperty(true);
  var pinStream = $body.asEventStream("keyup change input", ".modal #pin").map(c.$targetValue).toProperty("");
  pinStream.map(isPinEnteredAndNetPvrIsNotMissing).not().lazyAssign($, ".modal #pin", "toggleClass", "missing");
  $body.asEventStream("click input", ".modal #pin.error").map("error").lazyAssign($, "#pin, #check-pin", "removeClass");
  formHelpers.bubbleHover(".modal #pin.error", translate("invalid-pin-code"));
  return pinStream.map(isPinEnteredAndNetPvrIsNotMissing).not().and(paymentOptionRequiresPinCode);
}

function isPinEnteredAndNetPvrIsNotMissing(value) {
  return value.length === 4 && !$body.hasClass("requireNetPvrAccess");
}

function notDenied(value) {
  return value !== DENIED;
}

function setupInvalidEmailStream() {
  var emailStream = $body.asEventStream("input", ".modal #email-modal").map(c.$targetValue).map(c.removeWhiteSpace).toProperty("");
  var emailEmptyStream = emailStream.map(c.isEmpty);
  var marketingAccepted = marketingRequested();
  emailEmptyStream.onValue(c.toggleClass('#email-modal', 'missing'));
  marketingAccepted.filter(emailIsNotForBilling).onValue(c.toggleClass('#email-modal', 'required'));
  var invalidEmail = emailStream.map(validate.email).not().and(emailEmptyStream.not());
  invalidEmail.lazyAssign($, ".modal #email-modal", "toggleClass", "error");
  return (invalidEmail.or(emailEmptyStream).and(marketingAccepted)).or(invalidEmail.and(emailEmptyStream.not()));
}

function marketingRequested() {
  return $body.asEventStream('change', '.email input[name="marketingConsent"]').map(c.$targetValue).map(notDenied);
}

function setupFormValidation() {
  var invalidEmail = streams.invalidEmail;
  var notAgreed = streams.notAgreed;
  var notValidPin = streams.notValidPin;
  notAgreed.onValue(disableEmail);
  notAgreed.onValue(disablePurchase);
  notAgreed.onValue(disabledActivationCode);
  notValidPin.or(notAgreed).or(invalidEmail).filter(submitNotInProgress).onValue(disablePurchaseButton);
}

function submitNotInProgress() {
  return !$(".modal input[type='submit']").hasClass("progress");
}

function disableEmail(disabled) {
  $(".modal .email input[name='marketingConsent']").prop("disabled", disabled);
  if (!emailIsForBilling()) {
    $(".modal #email-modal").prop("disabled", disabled);
  }
  $(".modal .email").toggleClass("disabled", disabled);
}

function disablePurchase(disabled) {
  $(".modal #pin").prop("disabled", disabled);
  $(".modal .purchase").toggleClass("disabled", disabled);
}

function disablePurchaseButton(disabled) {
  $(".modal input[type='submit']").prop("disabled", disabled);
}

function disabledActivationCode(disabled) {
  $(".modal .activation-code input, .modal .activation-code button").prop("disabled", disabled);
  $(".modal .activation-code").toggleClass("disabled", disabled);
}

function isModalContainer(event) {
  return $(event.target).hasClass('modalContainer');
}

function closeEnabled() {
  return !$html.hasClass('modal-close-disabled');
}

function modalAnimationIsComplete() {
  return $html.hasClass("modal-open") && !$body.hasClass("modal-open-animation");
}

function marketingConsent(consent, termsAccepted) {
  return {
    allowed: consent === ALLOWED,
    denied: consent === DENIED || consent === UNKNOWN && termsAccepted,
    bulletin: consent === ALLOWED_BULLETIN || consent === UNKNOWN && !termsAccepted,
    internal: consent === ALLOWED_INTERNAL
  };
}

$body.on('click', '#modal-login-block .forgot-password', function (event) {
  c.stopEvent(event);
  $('#modal-login-block .password-retrieval').show();
  $('.modal-login').parents('.login-details').hide();
});
$body.asEventStream("click", '.modal [data-analytics="register"]').onValue(function () {
  ga.trackRegistrationStart("modal", $('[data-modal-type]').attr("data-modal-type"));
});
$body.on('click', '#modal-login-block .login-link', function (event) {
  c.stopEvent(event);
  $('#modal-login-block .password-retrieval').hide().removeClass('password-sent');
  $('.modal-login').parents('.login-details').show();
});

paymentOptionStream = $body.asEventStream('click change', '[name="payment-option"]').map(c.$targetValue);
paymentOptionStream.onValue(function (paymentType) {
  $('.modal .purchase').attr('data-payment-type', paymentType);
});

var clickOnBankLogo = $body.asEventStream('click', '.bank-payment input[type="submit"]');

function assignPaymentTypeToModalSubmit(event) {
  $('.modal input[name="submit-type"]').val($(event.target).attr('data-paymenttype'));
}
clickOnBankLogo.onValue(assignPaymentTypeToModalSubmit);

formHelpers.bubbleHover(".modal .verify-email-link .info", translate("registration_verify_account"));

streams = {
  notAgreed: setupAgreementNotCheckedStream(),
  invalidEmail: setupInvalidEmailStream(),
  notValidPin: setupInvalidPinStream()
};

closeModalStream = $body.asEventStream("click", ".modal .close").merge($body.asEventStream("click", ".modalContainer").filter(isModalContainer))
  .filter(modalAnimationIsComplete).filter(closeEnabled).doAction(c.stopEvent).merge($(document).asEventStream('keydown').map('.keyCode').filter(function (x) {
    return x === 27;
  }));
closeModalStream.onValue(closeModal);

modalOpenState = closeModalStream.map(false).merge(modalStream);

fullscreenState.assign($body, "toggleClass", "fullscreen");
modalOpenState.filter(c.isTrue).take(1).doAction(setupFormValidation).onValue(collapsible.setup);
mobileLinks.init();

methods = {
  open: function (templateName, data) {
    modalStream.push(true);
    $('.hover-container').hide();
    return Bacon.combineWith(renderModal, templates.get(templateName), Bacon.combineTemplate({
      "record-partial": templates.get("record-partial"),
      "record-active-wildcard-partial": templates.get("record-active-wildcard-partial"),
      "library-modal-login-partial": templates.get("library-modal-login-partial"),
      "library-modal-player-test-partial": templates.get("library-modal-player-test-partial"),
      "login-partial": templates.get("login-partial"),
      "login-register-partial": templates.get("login-register-partial"),
      "modal-login-partial": templates.get("modal-login-partial"),
      "modal-newsletter-partial": templates.get("modal-newsletter-partial"),
      "modal-player-test-partial": templates.get("modal-player-test-partial"),
      "mobile-links-partial": templates.get("mobile-links-partial"),
      "vod-web-payment-partial": templates.get("vod-web-payment-partial"),
      "library-netpvr-required": templates.get("library-netpvr-required")
    }), data.takeUntil(modalOpenState)).doAction(triggerOpen);
  },
  closeStream: modalStream.filter(c.isFalse),
  close: function () {
    if ($modal) {
      var $wrapper = $('.wrapper');
      var top = $wrapper.scrollTop();
      $wrapper.scrollTop(0);
      $html.removeClass('modal-open');
      modalStream.push(false);
      removeModal();
      fullscreen.push(false);

      // firefox hack
      window.setTimeout(function () {
        scroll.topTo(top);
      }, 0);
    }
  },
  fullscreen: function () {
    fullscreen.push(true);
  },
  isOpen: function () {
    return $html.hasClass('modal-open');
  },
  data: {
    marketingConsent: marketingConsent,
    isValidEmail: function (userEmail) {
      return validate.email(userEmail) && !c.isEmpty(userEmail);
    },
    triggerOpen: triggerOpen
  },
  center: function () {
    var $modalEl = $('.modal');
    var height = $modalEl.outerHeight();
    $modalEl.css('top', (window.innerHeight < height ? 0 : (window.innerHeight - height) / 2) + "px");
  },
  streams: streams
};

export default methods;



// WEBPACK FOOTER //
// ./web/js/modal.js